import React from 'react'
import "./faqs.css"
import faqs from "./data"
import FAQ from "./FAQ"

function FAQs() {
  return (
    <section id='faqs'>
      <h2>Frequently Asked Questions</h2>
      <p>
        Here are some of the questions I usually get. Click to toggle the answer, and if you still have some more questions, shoot me a message from the contact section.
      </p>
        <div className="container faqs__container" data-aos="fade-in">
          {
            faqs.map(faq=>(
              <FAQ key={faq.id} faq={faq}/>
            ))
          }
        </div>
    </section>
  )
}

export default FAQs
